import MuiAvatar, { AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';
import Skeleton from '@mui/material/Skeleton';

export interface AvatarProps {
  initials?: string;
  children?: React.ReactNode;
  src?: string;
  size?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  sx?: MuiAvatarProps['sx'];
}

export const Avatar: React.FC<AvatarProps> = ({
  initials,
  children,
  src,
  sx,
  size = 'medium',
}) => {
  const sizes = {
    xsmall: 24,
    small: 32,
    medium: 40,
    large: 64,
    xlarge: 80,
  };

  return (
    <MuiAvatar
      src={src}
      sx={[
        {
          width: sizes[size],
          height: sizes[size],
          textTransform: 'uppercase',
          bgcolor: src && 'avatar.defaultBg',
          color: 'text.secondary',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {initials || children}
    </MuiAvatar>
  );
};

export interface AvatarSkeletonProps {
  size?: AvatarProps['size'];
}
export const AvatarSkeleton: React.FC<AvatarSkeletonProps> = ({ size }) => {
  return (
    <Skeleton variant="circular">
      <Avatar size={size} />
    </Skeleton>
  );
};
